import { useQuery } from '@tanstack/react-query';

import { fetchShipmentVendorBranch } from '../data-provider/shipment-vendor-branch';
import type { GetShipmentVendorBranchRequestParams } from '../data-provider/shipment-vendor-branch/api';

export const useGetShipmentVendorBranch = (params: GetShipmentVendorBranchRequestParams) => {
  return useQuery({
    enabled: Boolean(params.customerKey),
    queryFn: () => fetchShipmentVendorBranch(params),
    queryKey: ['shipment-vendor-branch', params.customerKey],
    // biome-ignore lint/style/noMagicNumbers: 1 hour
    staleTime: 1000 * 60 * 60 * 24,
  });
};
